import { render, staticRenderFns } from "./ubicacion_tesoreria.vue?vue&type=template&id=058585ee&"
import script from "./ubicacion_tesoreria.vue?vue&type=script&lang=js&"
export * from "./ubicacion_tesoreria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports